import React from 'react';
import withReduxContainer, { OwnProps } from './ZoneGroup.container';
import { withSectionContext } from '../../../Sections/SectionContext';
import ZoneGroup from './ZoneGroup';

export default withSectionContext(
  withReduxContainer(ZoneGroup) as React.ComponentType<OwnProps>
);
